import React from "react";

import { createEvents } from "./electoral-geography/events";
import { createInitialState } from "./electoral-geography/state";

import GeographyHeader from "./electoral-geography/widgets/GeographyHeader";
import GeographyTree from "./electoral-geography/widgets/GeographyTree";
import SelectionPanel from "./electoral-geography/widgets/SelectionPanel";
import VotingCentersPanel from "./electoral-geography/widgets/VotingCentersPanel";
import GeographyContextMenu from "./electoral-geography/widgets/GeographyContextMenu";
import GeographyDialog from "./electoral-geography/widgets/GeographyDialog";

import styles from "./ElectoralGeographyPage.module.styl";

const ElectoralGeographyPage = ({ gui }) => {
  const [state, setState] = React.useState(createInitialState);
  const events = React.useMemo(() => createEvents(), []);

  return (
    <div className={styles.page}>
      <GeographyHeader loading={state.ui.loading} />

      {state.ui.error ? <div className={styles.error}>{state.ui.error}</div> : null}

      <div className={styles.workspace}>
        <GeographyTree gui={gui} state={state} setState={setState} events={events} />

        <section className={styles.detail}>
          <SelectionPanel gui={gui} state={state} setState={setState} events={events} />
          <VotingCentersPanel gui={gui} state={state} events={events} />
        </section>
      </div>

      <GeographyContextMenu gui={gui} state={state} setState={setState} events={events} />
      <GeographyDialog gui={gui} state={state} setState={setState} events={events} />
    </div>
  );
};

export const displayElectoralGeography = (gui) => {
  return {
    uuid: "electoral-geography",
    view: () => <ElectoralGeographyPage gui={gui} />,
  };
};

export default ElectoralGeographyPage;
